import { z } from "zod";

export const reviewStates = [
  "unprocessed",
  "acknowledged",
  "drafted",
  "saved",
  "processed",
  "ignored",
] as const;
export const reviewStateSchema = z.enum(reviewStates);
export type ReviewState = z.infer<typeof reviewStateSchema>;
export const reviewActionSchema = z.enum([
  "acknowledge",
  "draft",
  "save",
  "reset",
  "process",
  "ignore",
]);
export type ReviewAction = z.infer<typeof reviewActionSchema>;
export const reviewLabels: Record<ReviewState, string> = {
  acknowledged: "Acknowledged",
  unprocessed: "New",
  drafted: "Drafted",
  saved: "Saved",
  processed: "Processed",
  ignored: "Ignored",
};
export const reviewActions: Record<ReviewState, ReviewAction> = {
  acknowledged: "acknowledge",
  unprocessed: "reset",
  drafted: "draft",
  saved: "save",
  processed: "process",
  ignored: "ignore",
};
